import { Color, VehicleStatus } from "@daytrip/legacy-enums";
import { Expose, Transform, Type } from "class-transformer";
import { IsArray, IsDate, IsDefined, IsInt, IsString, IsUUID } from "class-validator";
import { v4 as uuid } from "uuid";

import { CDBaseEntity, CDColumn, CDCreateDateColumn, CDEntity, CDObjectIdColumn } from "../orm";
import { statusGetter } from "../statusGetter";
import { TransformToDate } from "../transformers/transformToDate";

import { Document } from "./Document";

@CDEntity("vehicles")
export class Vehicle extends CDBaseEntity {
    @CDObjectIdColumn()
    @IsUUID("4")
    @Expose()
    public _id: string = uuid();

    @CDColumn()
    @IsString()
    @IsDefined()
    @Expose()
    public licensePlate: string;

    @CDCreateDateColumn()
    @IsDate()
    @IsDefined()
    @Expose()
    @TransformToDate
    public createdAt: Date = new Date();

    @CDColumn()
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public ownerUserId: string;

    @CDColumn()
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public modelId: string;

    @CDColumn()
    @IsDate()
    @Expose()
    @TransformToDate
    public acceptedAt?: Date;

    @CDColumn()
    @IsDate()
    @Expose()
    @TransformToDate
    public declinedAt?: Date;

    @CDColumn()
    @IsDate()
    @Expose()
    @TransformToDate
    public deletedAt?: Date;

    @CDColumn()
    @IsString()
    @Expose()
    public declinationReason: string | undefined;

    @CDColumn()
    @IsInt()
    @IsDefined()
    @Expose()
    public color: Color;

    @CDColumn()
    @IsInt()
    @IsDefined()
    @Expose()
    public manufactureYear: number;

    @CDColumn()
    @IsArray()
    @IsDefined()
    @Expose()
    @Type(() => Document)
    public documents: Array<Document> = [];

    @CDColumn()
    @IsArray()
    @IsDefined()
    @Expose()
    @Transform((value: Array<string>) => value.sort((a, b) => (a > b ? 1 : b > a ? -1 : 0)))
    public photoIds: Array<string> = [];

    public get status(): VehicleStatus {
        return statusGetter(this, Vehicle, VehicleStatus);
    }

    public static statusPrototype(status: VehicleStatus): Vehicle {
        const defined = new Date();

        switch (status) {
            case VehicleStatus.Deleted:
                return {
                    deletedAt: defined,
                } as Vehicle;

            case VehicleStatus.Declined:
                return {
                    deletedAt: undefined,
                    declinedAt: defined,
                } as Vehicle;

            case VehicleStatus.Accepted:
                return {
                    deletedAt: undefined,
                    declinedAt: undefined,
                    acceptedAt: defined,
                } as Vehicle;

            case VehicleStatus.Pending:
            default:
                return {
                    deletedAt: undefined,
                    declinedAt: undefined,
                    acceptedAt: undefined,
                } as Vehicle;
        }
    }
}
